<template>

  <modalo
    :title="$t('Assign to job')"
    type="small"
    @hideModal="hideModal()">
    
    <form
      id="assign-form"
      v-on:submit.prevent="saveAssign(assign)">
      
      <div class="form-group">
        <label class="control-label">* {{ $t('Candidates') }}</label>
        <select-multiple-candidates
          v-model="assign.candidates">
          </select-multiple-candidates>
      </div>

      <div class="form-group">
        <label class="control-label">* {{ $t('Job') }}</label>
        <select-job 
          v-model="assign.job_id"
          :filters="{status: 'open'}"
          :limit="10">
          </select-job>
        <ValidateMessage
          :error="validateErrors.job_id" />
      </div>

    </form>

    <template slot="footer">
      <div :class="{'box-loading': loading}">
        <button
          type="submit"
          form="assign-form"
          class="btn btn-primary">Associar</button>
        <button
          type="button"
          class="btn btn-light"
          @click.stop="hideModal()">{{ $t('Cancel') }}</button>
      </div>
    </template>

  </modalo>

</template>

<script>
import SelectMultipleCandidates from '@/components/Fields/SelectMultipleCandidates'
import SelectJob from '@/components/Fields/SelectJob'

export default {
  name: 'MassiveAssign',
  components: {
    SelectMultipleCandidates,
    SelectJob
  },
  props: [
    'initAssign'
  ],
  data () {
    return {
      loading: false,
      validateErrors: false,
      assign: this.defaultValues(this.initAssign)
    }
  },
  computed: {
  },
  created () {
  },
  methods: {
    /*
    defaultValues
    */
    defaultValues (values) {
      return values._id
      ? this.$clone(values)
      : Object.assign({
      }, values)
    },
    /*
    hideModal
    */
    hideModal () {
      this.$emit('hideModal')
    },
    saveAssign (data) {
      this.loading = true

      return this.$store
      .dispatch('getStages', {type: 'sourced'})
      .then(stage => {
        return Promise.all(data.candidates.map((candidate) => {
          return this.$store
          .dispatch('createPlacement', {
            candidate_id: candidate._id,
            job_id: data.job_id,
            stage_id: stage[0]._id
          })
        }))
      })
      .then(() => {
        this.loading = false
        this.$emit('created', {})
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/MassiveAssign/MassiveAssign.vue